import { render } from "./ReferenceItemSelect.vue?vue&type=template&id=508b6424"
import script from "./ReferenceItemSelect.vue?vue&type=script&lang=js"
export * from "./ReferenceItemSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__